import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { GitBranch, ShieldCheck, User2 } from 'lucide-react';
import { EmptyStatePanel } from '@/components/common/EmptyStatePanel';
import { getAIEngineeringModuleLabel, getAIEngineeringRiskLabel, getAIEngineeringRiskTone, getAIEngineeringStatusLabel, getAIEngineeringStatusTone } from '@/lib/aiEngineeringLabels';

export const AIEngineeringTaskHeader = ({ task }) => {
  if (!task) {
    return <EmptyStatePanel title="Nenhuma task seleccionada" description="Seleccione uma task no histórico ou crie uma nova para abrir o cockpit de decisão." ctaLabel={null} testId="ai-engineering-empty-task-header" />;
  }

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="ai-engineering-task-summary-card">
      <CardHeader className="space-y-3 pb-3">
        <div className="flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between">
          <div className="space-y-2">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Task activa</p>
            <CardTitle className="text-lg font-semibold text-slate-950">{task.title}</CardTitle>
            <p className="max-w-3xl text-sm text-slate-600">{task.request_text}</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Badge variant="outline" className={`rounded-sm border ${getAIEngineeringStatusTone(task.status)}`}>{getAIEngineeringStatusLabel(task.status)}</Badge>
            <Badge variant="outline" className={`rounded-sm border ${getAIEngineeringRiskTone(task.risk_level)}`}>Risco {getAIEngineeringRiskLabel(task.risk_level)}</Badge>
            <Badge variant="outline" className="rounded-sm border-slate-300 bg-white text-slate-700">{getAIEngineeringModuleLabel(task.module_target)}</Badge>
          </div>
        </div>
      </CardHeader>
      <CardContent className="grid gap-3 md:grid-cols-3">
        <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Solicitado por</p>
          <p className="mt-2 flex items-center gap-2 font-medium text-slate-900"><User2 className="h-4 w-4 text-slate-500" /> {task.requested_by_name || 'Utilizador'}</p>
        </div>
        <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Artefactos mockados</p>
          <p className="mt-2 font-medium text-slate-900">{task.changed_files?.length || 0} ficheiros simulados</p>
          <p className="text-xs text-slate-500">Patch, logs e PR payload existem apenas como dados persistidos.</p>
        </div>
        <div className="rounded-sm border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700">
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500">Open PR mock</p>
          {task.open_pr_payload ? (
            <div className="mt-2 space-y-1 text-xs text-slate-600">
              <p className="flex items-center gap-2 font-medium text-slate-900"><GitBranch className="h-4 w-4 text-slate-500" /> {task.open_pr_payload.branch_name}</p>
              <p>{task.open_pr_payload.pr_title}</p>
            </div>
          ) : (
            <p className="mt-2 flex items-center gap-2 text-xs text-slate-500"><ShieldCheck className="h-4 w-4" /> Ainda não preparado.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};